import { FC } from 'react';

import { ModalComponent } from './ModalComponent';
import { useModalState } from './useModalState';

import '@alto-avios/alto-tokens/web/avios/fonts.css';

export const Modal: FC = () => {
  const modal = useModalState();

  if (!modal.isOpen) {
    return null;
  }

  return <ModalComponent data={modal.data} onClose={modal.close} />;
};
